import {
  AppBar,
  Dialog,
  DialogContent,
  Icon,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select from 'react-select';

export default function MarketingTotalSummary(props) {
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([
    { field: "categoryName", headerName: "Category", width: 250 },
    {
      field: "janBudget",
      headerName: `Jan`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "febBudget",
      headerName: `Feb`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "marBudget",
      headerName: `Mar`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "aprBudget",
      headerName: `Apr`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "mayBudget",
      headerName: `May`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "junBudget",
      headerName: `Jun`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "julBudget",
      headerName: `Jul`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "augBudget",
      headerName: `Aug`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "sepBudget",
      headerName: `Sep`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "octBudget",
      headerName: `Oct`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "novBudget",
      headerName: `Nov`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "decBudget",
      headerName: `Dec`,
      enableRowGroup: true,
      aggFunc: "sum",
      suppressFilter: true,
    },
    {
      field: "total",
      headerName: `Total`,
      editable: false,
      minWidth: 100,
      cellStyle: { "background-color": "#FFA726" },
    },
    {
      field: "actual",
      headerName: `Actual`,
      editable: false,
      minWidth: 100,
      cellStyle: { "background-color": "#F6511D" },
    },
    {
      headerName: `Variation`,
      children: [
        {
          field: "amount",
          headerName: `Amount`,
          editable: false,
          minWidth: 120,
          cellStyle: { "background-color": "#6A5837" },
        },
        {
          field: "percentage",
          headerName: `Percentage %`,
          editable: false,
          minWidth: 100,
          cellStyle: { "background-color": "#7FB800" },
        },
      ],
    },
  ]);
  const gridRef = useRef();
  const ref = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [selectedBudget, setSelectedBudget] = useState({ value: 'budgetValues', label: 'Budget' });

  const loadData = () => {
    setRowData(props.data.map((d) => sanitizeRowForGrid(d)));
  };
  const getBudgetTotal = (budgets = [], budgetKey = "budgetValues") => {
    return (
      budgets?.[budgetKey].JANUARY +
      budgets?.[budgetKey].FEBRUARY +
      budgets?.[budgetKey].MARCH +
      budgets?.[budgetKey].APRIL +
      budgets?.[budgetKey].MAY +
      budgets?.[budgetKey].JUNE +
      budgets?.[budgetKey].JULY +
      budgets?.[budgetKey].AUGUST +
      budgets?.[budgetKey].SEPTEMBER +
      budgets?.[budgetKey].OCTOBER +
      budgets?.[budgetKey].NOVEMBER +
      budgets?.[budgetKey].DECEMBER
    );
  };
  const sanitizeRowForGrid = (d, index, budgetKey = "budgetValues") => {
    const totalBudget = getBudgetTotal(d.budgets, "budgetValues");
    const actualBudget = getBudgetTotal(d.budgets, "actualValues");
    const amount = totalBudget - actualBudget;
    const percentage =
      actualBudget == 0 ? 0 : ((amount / actualBudget) * 100).toFixed();
    return {
      ...d,
      janBudget: d.budgets?.[budgetKey].JANUARY,
      febBudget: d.budgets?.[budgetKey].FEBRUARY,
      marBudget: d.budgets?.[budgetKey].MARCH,
      aprBudget: d.budgets?.[budgetKey].APRIL,
      mayBudget: d.budgets?.[budgetKey].MAY,
      junBudget: d.budgets?.[budgetKey].JUNE,
      julBudget: d.budgets?.[budgetKey].JULY,
      augBudget: d.budgets?.[budgetKey].AUGUST,
      sepBudget: d.budgets?.[budgetKey].SEPTEMBER,
      octBudget: d.budgets?.[budgetKey].OCTOBER,
      novBudget: d.budgets?.[budgetKey].NOVEMBER,
      decBudget: d.budgets?.[budgetKey].DECEMBER,
      total: totalBudget,
      actual: budgetKey === "actualValues" ? undefined : actualBudget,
      amount: amount,
      percentage: `${percentage}%`,
    };
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const defaultColDef = useMemo(() => {
    return {
      resizable: true,
      width: 100,
    };
  }, []);

  const onGridReady = useCallback((params) => {
    gridRef.current = params;
    setGridApi(params.api);
  }, []);

  const options = [
    { value: 'budgetValues', label: 'Budget' },
    { value: 'actualValues', label: 'Actuals' },
    { value: 'forecastValues', label: 'Forecast' },
  ];

  const changeBudget = (data) => {
    setSelectedBudget(data);
    if (data.value === 'actualValues') {
      colHide(false);
    } else {
      colHide(true);
    }
  };
  const colHide = (show) => {
    console.log(gridRef.current)
    gridRef.current.columnApi.setColumnsVisible(['actual', 'amount', 'percentage'], show)
  }

  return (
    <Dialog
      open={props.totalSummaryDialog}
      onClose={props.handleTotalSummaryDialogClose}
      fullWidth
      maxWidth="lg"
    >
      <AppBar position="static">
        <Toolbar className="flex w-full justify-between">
          <Typography variant="subtitle1" color="inherit">
            Category Budget Summary
          </Typography>
          <IconButton onClick={props.handleTotalSummaryDialogClose}>
            <Icon>close</Icon>
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent classes={{ root: "p-16 sm:p-24" }}>
        <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8 pb-16 px-16">
            {/* <Select
              name="budgetSummary"
              value={selectedBudget}
              options={options}
              onChange={changeBudget}
              styles={customStyles()}
            /> */}
          </div>
        <div
          className="ag-theme-alpine-dark"
          style={{ height: 300, width: "100%" }}
        >
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            // gridRef={gridRef}
            defaultColDef={defaultColDef}
            // autoGroupColumnDef={autoGroupColumnDef}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
